import updateCart from './update-popup-cart.js';
import updatedPromosList from './update-promo-list';
import { postData } from './fetch';

window.addEventListener('load', () => {
  const buyButtons = document.querySelectorAll('.buy-button');
  const variantInput = document.querySelectorAll('.variant-input');

  if (variantInput) {
    [].forEach.call(variantInput, (input) => {
      input.addEventListener('change', () => {
        const { id } = input.dataset;
        const productCard = input.closest('.product-card');
        let productDescription;
        let childrenImageWrapper;
        let buyWrapper;
        let productInformation;

        if (productCard) {
          productDescription = productCard.querySelectorAll(
            '.product-description-text span',
          );

          childrenImageWrapper = productCard.querySelectorAll(
            '.children-image-wrapper',
          );

          buyWrapper = productCard.querySelectorAll('.buy-wrapper');
          productInformation = productCard.querySelectorAll('.product-info');
        }

        if (productDescription) {
          [].forEach.call(productDescription, (item) =>
            item.classList.remove('visible'),
          );
        }

        if (productInformation) {
          [].forEach.call(productInformation, (item) =>
            item.classList.remove('visible'),
          );
        }

        if (
          productCard &&
          productCard.querySelector(
            `.product-description-text span[data-id="${id}"]`,
          )
        ) {
          productCard
            .querySelector(`.product-description-text span[data-id="${id}"]`)
            .classList.add('visible');
        }

        if (buyWrapper) {
          [].forEach.call(buyWrapper, (wrapper) =>
            wrapper.classList.remove('visible'),
          );
        }

        if (
          productCard &&
          productCard.querySelector(`.buy-wrapper[data-id="${id}"]`)
        ) {
          productCard
            .querySelector(`.buy-wrapper[data-id="${id}"]`)
            .classList.add('visible');
        }

        if (document.getElementById(`info-${id}`)) {
          document.getElementById(`info-${id}`).classList.add('visible');
        }

        if (childrenImageWrapper) {
          [].forEach.call(childrenImageWrapper, (wrapper) =>
            wrapper.classList.remove('visible'),
          );
        }

        if (document.getElementById(`image-${id}`)) {
          document.getElementById(`image-${id}`).classList.add('visible');
        }

        if (productCard) {
          productCard.dataset.id = id;
        }
      });
    });
  }

  if (buyButtons) {
    [].forEach.call(buyButtons, (btn) => {
      btn.addEventListener('click', async () => {
        let countInput;
        let notAvailableWrapper;
        let availableWrapper;
        let buttonMinus;
        let buttonPlus;
        let parentElement = btn.closest('.buy-wrapper');

        const body = {
          id: btn.dataset.id,
        };

        if (!btn.dataset.product) {
          if (!parentElement) {
            parentElement = btn.closest('.product-card');
          }

          body.quantity = 1;
        } else {
          if (parentElement) {
            countInput = parentElement.querySelector('.count-input');
            buttonMinus = parentElement.querySelector('.minus');
            buttonPlus = parentElement.querySelector('.plus');
            notAvailableWrapper = parentElement.querySelector('.not-available');
            availableWrapper = parentElement.querySelector('.available');
          } else {
            countInput = document.querySelector('.count-input');
            buttonMinus = document.querySelector('.minus');
            buttonPlus = document.querySelector('.plus');
            notAvailableWrapper = document.querySelector('.not-available');
            availableWrapper = document.querySelector('.available');
          }
          body.quantity = countInput.value;
        }

        btn.classList.add('loading');

        if (!btn.dataset.product) {
          btn.textContent = 'Загрузка...';
        }

        const response = await postData("/cart", body);

        if (response) {
          if (response.statusCode === 200) {
            updateCart(response.data, response.data.additional);

            if (!btn.dataset.product) {
              if (parentElement) {
                const countButton = parentElement.querySelector(
                  '.count-button',
                );

                if (countButton) {
                  countButton.classList.add('visible');
                  btn.classList.add('hidden');
                }
              }

              updatedPromosList(response.data.promos);
            } else {
              const currentProduct = response.data.cartItems.find(
                (item) => item.productId === btn.dataset.id,
              );

              if (currentProduct) {
                countInput.dataset.quantity = currentProduct.quantity;

                if (currentProduct.quantity === 99) {
                  notAvailableWrapper.classList.add('visible');
                  availableWrapper.classList.add('hidden');
                }
              }

              if (buttonMinus) {
                buttonMinus.classList.add('disabled');
              }

              if (buttonPlus) {
                buttonPlus.classList.add('disabled');
              }

              btn.classList.remove('loading');
              btn.textContent = `Добавлено (${countInput.value})`;
              btn.classList.add('product-added');

              const { price } = btn.dataset;

              setTimeout(() => {
                if (!btn.classList.contains('non-removed')) {
                  btn.classList.remove('product-added');
                  btn.innerHTML = `В корзину за <span>${price}</span> ₽`;
                }

                countInput.value = 1;
                buttonPlus.classList.remove('disabled');

                if (document.querySelector('.product-popup-wrapper')) {
                  document
                    .querySelector('.product-popup-wrapper')
                    .classList.remove('active');
                }

                document.body.style.overflow = 'auto';
              }, 2500);
            }
          } else {
            const { price } = btn.dataset;

            btn.classList.remove('loading');
            btn.innerHTML = `В корзину за <span>${price}</span> ₽`;
          }
        }
      });
    });
  }
});
